'use client';

import { Icons } from '@/components/Shares/Icons';
import modalStyle from '@/components/Shares/Modal.module.css';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { Flex, Group, Image, Modal, useMatches } from '@mantine/core';
import { InfoPhoneVerify } from './InfoPhoneVerify';
import { InfoPhoneVerifySuccess } from './InfoPhoneVerifySuccess';
export const InfoPhoneVerifyModal: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  const {
    verify
  } = useVerifyProfile();
  const src = useMatches({
    base: '/assets/profile/character_bottom.png',
    lg: '/assets/bottom-character.svg'
  });
  return <Modal opened={openModal === MODAL.VERIFY_EMAIL} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.95)'
  }} size="100%" classNames={modalStyle}>
      <Group pos="absolute" bottom={0} left={0} right={0} justify="center">
        <Image src={src} alt="character" w={{
        base: 256,
        md: 350,
        lg: 357
      }} h={{
        base: 182,
        md: 250,
        lg: 254
      }} />
      </Group>

      <Flex justify="center" w="100%">
        <Flex h="100%" align="center" justify="center" maw={1320} w={{
        base: '100%',
        sm: 722,
        md: 1320
      }} pb={{
        base: 182,
        md: 250,
        lg: 254
      }}>
          {!verify ? <InfoPhoneVerify /> : <InfoPhoneVerifySuccess />}
        </Flex>
      </Flex>
    </Modal>;
};